import {Directive, ElementRef, OnInit} from '@angular/core'

@Directive({
  selector: '[feAutofocus]'
})
export class AutofocusDirective implements OnInit {

  constructor(private elementRef: ElementRef) { };

  ngOnInit() {
    this.elementRef.nativeElement.focus()
  }
}
